<div class="desktop-view">
    <main @fade>
        <div class="order-title">
            <h1>Корзина</h1>
        </div>

        <form class="basket-top">
            <div class="basket-top__left">

                <div class="form-group__search" *ngIf="cartProductList.length">
                    <input nbInput fullWidth
                           fieldSize="small"
                           i18n-placeholder="@@SearchInTheCart"
                           placeholder="Поиск в корзине"
                           name="keyword" [(ngModel)]="keyword" (keyup)="onFilter()">
                    <nb-icon icon="search-outline" class="form-group__search-icon"></nb-icon>
                </div>

                <button size="small" nbButton class="toolbar-btn toolbar-btn--import" [matMenuTriggerFor]="cartImportMenu">
                  <nb-icon icon="upload-outline"></nb-icon>
                  <span>Импорт в корзину</span>
                </button>
                <mat-menu #cartImportMenu="matMenu">
                  <button class="mat-mdc-menu-item" mat-menu-item (click)="openAddToCartManually()">
                    <nb-icon icon="edit-outline"></nb-icon> Вручную
                  </button>
                  <button class="mat-mdc-menu-item" mat-menu-item (click)="openAddToCartByFile()">
                    <nb-icon icon="file-text-outline"></nb-icon> Файлом
                  </button>
                </mat-menu>

                <div *ngIf="settings.usePromoCodes">
                    <app-promo-code *nbIsGranted="['view','authorized-block']"/>
                </div>
            </div>

            <div class="basket-top__right">
                <div class="total" *ngIf="selectedRows.size">
                    <small i18n="@@TotalWeight" *ngIf="showTotalWeight" class="total-weight">
                        Общий вес: {{ totalWeight | formatPriceNumber }} <span>кг</span>
                    </small>
                    <small i18n="@@TotalVolume" *ngIf="showTotalVolume" class="total-volume">
                        Общий объем: {{ totalVolume | formatPriceNumber }} <span>м3</span>
                    </small>
                </div>
              <button size="small" nbButton class="toolbar-btn toolbar-btn--clear" *ngIf="canEdit && cartProductList.length" (click)="openSpecificationForm()">
                <span>Создать черновик</span>
                <nb-icon icon="file-outline"></nb-icon>
              </button>
                <button size="small" nbButton class="toolbar-btn toolbar-btn--clear" *ngIf="canEdit && cartProductList.length" (click)="clearCartConfirm()">
                  <span i18n="@@Clear">Очистить корзину</span>
                  <nb-icon icon="trash-2-outline"></nb-icon>
                </button>
            </div>

            <ng-template #priceTemplate let-price="price">
                <span class="price-main">{{ price.main }}</span>
                <span class="price-cents">.{{ price.cents }}</span>
                <span class="curr"> ₽</span>
            </ng-template>
        </form>

        <div class="cart-layout">
        <nb-card class="cart-table">
            <div class="all-table" [nbSpinner]="refreshing" nbSpinnerSize="large" nbSpinnerStatus="primary">
                <grid-gear [list]="this"/>
                <ngx-table [configuration]="configuration"
                           [data]="cartProductListFiltered"
                           #table
                           (event)="eventEmitted($event)"
                           [columns]="columns">
                </ngx-table>
            </div>

            <ng-template #photoTpl let-row>
                <div class="responsive-table" i18n-data-th="@@Picture" data-th="Фото">
                    <div class="photo-table">
                        <div class="photo-table__picture" *ngIf="row.syncUid">
                            <a class="mouse-pointer" (click)="openModalProduct(row.syncUid)">
                                <img [src]="getImageUri(row.picture)" alt="">
                            </a>
                        </div>

                        <div class="photo-table__picture" *ngIf="!row.syncUid">
                            <a class="mouse-pointer">
                                <img [src]="getImageUri(row.picture)" alt="">
                            </a>
                        </div>
                    </div>
                </div>
            </ng-template>

            <ng-template #headerTpl let-row>
                <div class="responsive-table" i18n-data-th="@@CodeTitle" data-th="Наименование">
                    <div class="name-table">

                        <div class="name-table__vendor-code" *ngIf="row.productCode">{{ row.productCode }}</div>

                        <div class="name-table__title">
                            <p *ngIf="row.syncUid"><span class="mouse-pointer table-row-value" (click)="openModalProduct(row.syncUid)">{{ row.header }}</span></p>
                            <p *ngIf="!row.syncUid"><span class="mouse-pointer table-row-value">{{ row.header }}</span></p>
                        </div>

                        <app-product-markers [product]="row" [inline]="true"/>
                    </div>

                    <div class="alert alert-warning" *ngIf="row.available === false" i18n="@@NoPriceForContract">
                        <span>Нет цены по выбранному договору — товар недоступен к заказу</span>
                    </div>
                    <div class="alert alert-warning" *ngIf="productService.isOutOfProduction(row)">
                        <span i18n="@@ProductOutOfStock">Товар выведен из ассортимента, вы можете заказать не более {{ productService.countAvailability(row) }} <span> {{ row.unitHeader }}</span></span>
                    </div>
                    <div class="alert alert-warning" *ngIf="productService.isOutOfMultiplicity(row)">
                        <span i18n="@@ProductSupplyWithMultiplicity">Товар поставляется под заказ кратно {{ row.multiplicitySupplier }} <span>{{ row.unitHeader }}</span>. Рекомендуем изменить количество товара в заказе</span>
                    </div>
                    <div class="alert alert-warning" *ngIf="productService.outOfStockAndHasAnalogs(row)">
                        <span i18n="@@ProductSupplyWithMultiplicityWithLink">На складе отсутствует товар. <a [routerLink]="['/product',row.syncUid,'analogs']" [queryParams]="{'q':row.amount, 'region': productService.customerGroup.id}">Подберите&nbsp;аналог</a></span>
                    </div>

                </div>
            </ng-template>

            <ng-template #supplyTermTpl let-row>
                {{ productService.getSupplyTerm(row) }}
            </ng-template>

            <ng-template #wmsTpl let-row let-column="column">
                <app-product-wms [product]="row" [column]="column"/>
            </ng-template>

            <ng-template #priceTpl let-row>
                <app-product-price [product]="row"/>
            </ng-template>

            <ng-template #priceVATTpl let-row>
                <app-product-price [product]="row" [showVAT]="true"/>
            </ng-template>

            <ng-template #sumTpl let-row>
                <app-product-price [product]="row" [amount]="row.amount"/>
            </ng-template>

            <ng-template #sumVATTpl let-row>
                <app-product-price [product]="row" [amount]="row.amount" [showVAT]="true"/>
            </ng-template>
            <ng-template #deliveryAtpTpl let-row>
                <div class="responsive-table" i18n-data-th="@@DeliveryAtp" data-th="Дата готовности">
                    {{ (row.deliveryAtp | date: "dd.MM.yyyy") || '-' }}
                </div>
            </ng-template>

            <ng-template #cartTpl let-row>
                <div class="responsive-table table-mobile-cart" i18n-data-th="@@AddToCart" data-th="Количество">
                    <app-cart-table-amount [canEdit]="!shareSyncUid" [cartProduct]="row"></app-cart-table-amount>
                </div>
            </ng-template>

            <ng-template #removeTpl let-row>
                <button (click)="remove(row)" nbButton status="control">
                    <nb-icon icon="trash-2-outline"/>
                </button>
            </ng-template>

            <ng-template #codeIconTpl let-row data-th="Код">
                <div class="responsive-table product-list__table-code" data-th="Код">
                    <p>
                        <span class="mouse-pointer table-row-value" (click)="openModalProduct(row.syncUid)" [textContent]="row.articul"></span>
                    </p>
                </div>
                <app-code-icons [row]="row"/>
            </ng-template>

        </nb-card>

        <app-cart-order-block *ngIf="canEdit && !(isMobile$ | async)"
                              [products]="orderableSelectedRows"
                              [totalCost]="effectiveTotalCost"
                              [totalCostVAT]="effectiveTotalCostVAT"
                              [totalAmount]="selectedTotalAmount"
                              [canEdit]="canEdit"
                              (deliveryAddressChange)="onDeliveryAddressChange($event)"
                              (exportXls)="exportXlsFromBlock()"
                              (orderConfirmationVisibleChange)="onOrderConfirmationVisibleChange($event)"/>
        </div>

    </main>
</div>

<div class="mobile-view" *ngIf="cartProductListFiltered.length || cartProductList.length || orderConfirmationVisible">

    <div class="mobile-content" [class.has-footer]="showMobileFooter">
        <div class="mobile-header">
            <h1 i18n="@@Cart">Корзина</h1>
            <div class="mobile-search-row">
                <div class="mobile-search">
                    <nb-icon icon="search-outline" class="mobile-search-icon" aria-hidden="true"></nb-icon>
                    <input nbInput fullWidth
                           class="mobile-search-input"
                           fieldSize="small"
                           i18n-placeholder="@@SearchInTheCart"
                           placeholder="Поиск в корзине"
                           [(ngModel)]="keyword"
                           (keyup)="onFilter()">
                </div>
                <div class="mobile-more-wrap">
                    <button class="mobile-more-btn" type="button" aria-label="Дополнительные действия"
                            (click)="toggleMobileMoreMenu($event)">
                        <nb-icon icon="more-vertical-outline"></nb-icon>
                    </button>
                    <div class="mobile-more-panel" *ngIf="mobileMoreOpen" role="menu">
                        <button type="button" class="mobile-more-item" *ngIf="canEdit && cartProductList.length"
                                (click)="onMobileMoreAction('spec')">
                            <nb-icon icon="file-outline"></nb-icon>
                            <span i18n="@@CreateSpecification">Создать черновик</span>
                        </button>
                        <button type="button" class="mobile-more-item" *ngIf="cartProductList.length"
                                [disabled]="selectedRows.size === 0"
                                (click)="onMobileMoreAction('xls')">
                            <nb-icon icon="download-outline"></nb-icon>
                            <span i18n="@@SaveToXLS">Сохранить в XLS</span>
                        </button>
                        <button type="button" class="mobile-more-item" *ngIf="canEdit && cartProductList.length"
                                (click)="onMobileMoreAction('clear')">
                            <nb-icon icon="trash-2-outline"></nb-icon>
                            <span i18n="@@Clear">Очистить корзину</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="mobile-actions" *ngIf="cartProductListFiltered.length">
            <nb-checkbox
                    [checked]="isAllSelectedOnMobile()"
                    (checkedChange)="toggleSelectAllOnMobile()"
                    i18n="@@SelectAll">
                Выбрать все
            </nb-checkbox>
            <button class="btn-secondary mobile-manage-btn" type="button" (click)="mobileManageButtonAction()">
                {{ mobileManageButtonText }}
            </button>
        </div>

        <div class="product-cards">
            <div class="product-card" *ngFor="let row of cartProductListFiltered; trackBy: trackByProductId">
                <div class="card-image">
                    <a *ngIf="row.syncUid" (click)="openModalProduct(row.syncUid)">
                        <img [src]="getImageUri(row.picture)" alt="">
                    </a>
                    <img *ngIf="!row.syncUid" [src]="getImageUri(row.picture)" alt="">
                    <div class="card-checkbox">
                        <nb-checkbox
                                [checked]="selected.has(row.id)"
                                (checkedChange)="selectRow(row, $event)">
                        </nb-checkbox>
                    </div>
                </div>

                <div class="card-info">
                    <app-product-markers [product]="row" [inline]="true"/>
                    <div class="info-row">
                        <span class="articul-value">{{ row.articul }}</span>
                    </div>
                    <div class="info-row">
            <span class="product-name" [class.clickable]="row.syncUid" (click)="row.syncUid && openModalProduct(row.syncUid)">
              {{ row.header }}
            </span>
                    </div>
                    <div class="info-row price-row">
                        <ng-container *ngTemplateOutlet="priceTemplate; context: { price: getFormattedPrice((row.commercePrice?.price ?? 0) * row.amount) }"></ng-container>
                        <span class="price-label" i18n="@@Sum">cумма</span>
                    </div>
                    <div class="info-row price-row__nds">
                        <ng-container *ngTemplateOutlet="priceTemplate; context: { price: getFormattedPrice((row.commercePrice?.priceNds ?? 0) * row.amount) }"></ng-container>
                        <span class="price-label" i18n="@@SumTax">cумма с НДС</span>
                    </div>
                    <div class="info-row">
                        <span class="supply-label" i18n="@@SupplyTerm">Поставка дней:</span>
                        <span class="supply-value">{{ productService.getSupplyTerm(row) }}</span>
                    </div>

                    <div class="alert alert-warning" *ngIf="productService.isOutOfProduction(row)">
                        <span i18n="@@ProductOutOfStock">Товар выведен из ассортимента, вы можете заказать не более {{ productService.countAvailability(row) }} <span>{{ row.unitHeader }}</span></span>
                    </div>
                    <div class="alert alert-warning" *ngIf="productService.isOutOfMultiplicity(row)">
                        <span i18n="@@ProductSupplyWithMultiplicity">Товар поставляется под заказ кратно {{ row.multiplicitySupplier }} <span>{{ row.unitHeader }}</span>. Рекомендуем изменить количество товара в заказе</span>
                    </div>
                    <div class="alert alert-warning" *ngIf="productService.outOfStockAndHasAnalogs(row)">
                        <span i18n="@@ProductSupplyWithMultiplicityWithLink">На складе отсутствует товар. <a [routerLink]="['/product',row.syncUid,'analogs']" [queryParams]="{'q':row.amount, 'region': productService.customerGroup.id}">Подберите&nbsp;аналог</a></span>
                    </div>
                </div>

                <div class="card-actions">
                    <app-cart-table-amount [canEdit]="!shareSyncUid" [cartProduct]="row"></app-cart-table-amount>
                    <button class="mobile-more-btn" status="control" (click)="remove(row)">
                        <nb-icon icon="trash-2-outline"></nb-icon>
                    </button>
                </div>
            </div>
        </div>

        <app-cart-order-block *ngIf="canEdit && (isMobile$ | async)"
                              class="mobile-order-block"
                              [products]="orderableSelectedRows"
                              [totalCost]="effectiveTotalCost"
                              [totalCostVAT]="effectiveTotalCostVAT"
                              [totalAmount]="selectedTotalAmount"
                              [canEdit]="canEdit"
                              (deliveryAddressChange)="onDeliveryAddressChange($event)"
                              (exportXls)="exportXlsFromBlock()"
                              (orderConfirmationVisibleChange)="onOrderConfirmationVisibleChange($event)"/>
    </div>

    <div class="mobile-footer" *ngIf="showMobileFooter">
        <div class="footer-totals">
            <div class="total-row" i18n="@@Total" [title]="getTotalCostHint()">
                Итого:
                <ng-container *ngTemplateOutlet="priceTemplate; context: { price: getFormattedPrice(getSelectedTotalCost()) }"></ng-container>
            </div>
            <div class="total-row" i18n="@@TotalWithVat" [title]="getTotalCostHint()">
                Итого с НДС:
                <ng-container *ngTemplateOutlet="priceTemplate; context: { price: getFormattedPrice(getSelectedTotalCostVATBase()) }"></ng-container>
            </div>
        </div>

    </div>
</div>
